/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "вчера",
        "-2": "завчера",
        "0": "денес",
        "1": "утре",
        "2": "задутре",
        "future": {
          "one": "за {0} ден",
          "other": "за {0} дена"
        },
        "past": {
          "one": "пред {0} ден",
          "other": "пред {0} дена"
        }
      },
      "day-narrow": {
        "-1": "вчера",
        "-2": "завчера",
        "0": "денес",
        "1": "утре",
        "2": "задутре",
        "future": {
          "one": "за {0} ден",
          "other": "за {0} дена"
        },
        "past": {
          "one": "пред {0} ден",
          "other": "пред {0} дена"
        }
      },
      "day-short": {
        "-1": "вчера",
        "-2": "завчера",
        "0": "денес",
        "1": "утре",
        "2": "задутре",
        "future": {
          "one": "за {0} ден",
          "other": "за {0} дена"
        },
        "past": {
          "one": "пред {0} ден",
          "other": "пред {0} дена"
        }
      },
      "hour": {
        "0": "часов",
        "future": {
          "one": "за {0} час",
          "other": "за {0} часа"
        },
        "past": {
          "one": "пред {0} час",
          "other": "пред {0} часа"
        }
      },
      "hour-narrow": {
        "0": "часов",
        "future": {
          "one": "за {0} час",
          "other": "за {0} часа"
        },
        "past": {
          "one": "пред {0} час",
          "other": "пред {0} часа"
        }
      },
      "hour-short": {
        "0": "часов",
        "future": {
          "one": "за {0} час",
          "other": "за {0} часа"
        },
        "past": {
          "one": "пред {0} час",
          "other": "пред {0} часа"
        }
      },
      "minute": {
        "0": "оваа минута",
        "future": {
          "one": "за {0} минута",
          "other": "за {0} минути"
        },
        "past": {
          "one": "пред {0} минута",
          "other": "пред {0} минути"
        }
      },
      "minute-narrow": {
        "0": "оваа минута",
        "future": {
          "one": "за {0} мин.",
          "other": "за {0} мин."
        },
        "past": {
          "one": "пред {0} мин.",
          "other": "пред {0} мин."
        }
      },
      "minute-short": {
        "0": "оваа минута",
        "future": {
          "one": "за {0} мин.",
          "other": "за {0} мин."
        },
        "past": {
          "one": "пред {0} мин.",
          "other": "пред {0} мин."
        }
      },
      "month": {
        "-1": "минатиот месец",
        "0": "овој месец",
        "1": "следниот месец",
        "future": {
          "one": "за {0} месец",
          "other": "за {0} месеци"
        },
        "past": {
          "one": "пред {0} месец",
          "other": "пред {0} месеци"
        }
      },
      "month-narrow": {
        "-1": "минатиот месец",
        "0": "овој месец",
        "1": "следниот месец",
        "future": {
          "one": "за {0} месец",
          "other": "за {0} месеци"
        },
        "past": {
          "one": "пред {0} месец",
          "other": "пред {0} месеци"
        }
      },
      "month-short": {
        "-1": "минатиот месец",
        "0": "овој месец",
        "1": "следниот месец",
        "future": {
          "one": "за {0} месец",
          "other": "за {0} месеци"
        },
        "past": {
          "one": "пред {0} месец",
          "other": "пред {0} месеци"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "последното тромесечје",
        "0": "ова тромесечје",
        "1": "следното тромесечје",
        "future": {
          "one": "за {0} тромесечје",
          "other": "за {0} тромесечја"
        },
        "past": {
          "one": "пред {0} тромесечје",
          "other": "пред {0} тромесечја"
        }
      },
      "quarter-narrow": {
        "-1": "последното тромесечје",
        "0": "ова тромесечје",
        "1": "следното тромесечје",
        "future": {
          "one": "за {0} тромес.",
          "other": "за {0} тромес."
        },
        "past": {
          "one": "пред {0} тромес.",
          "other": "пред {0} тромес."
        }
      },
      "quarter-short": {
        "-1": "последното тромесечје",
        "0": "ова тромесечје",
        "1": "следното тромесечје",
        "future": {
          "one": "за {0} тромес.",
          "other": "за {0} тромес."
        },
        "past": {
          "one": "пред {0} тромес.",
          "other": "пред {0} тромес."
        }
      },
      "second": {
        "0": "сега",
        "future": {
          "one": "за {0} секунда",
          "other": "за {0} секунди"
        },
        "past": {
          "one": "пред {0} секунда",
          "other": "пред {0} секунди"
        }
      },
      "second-narrow": {
        "0": "сега",
        "future": {
          "one": "за {0} сек.",
          "other": "за {0} сек."
        },
        "past": {
          "one": "пред {0} сек.",
          "other": "пред {0} сек."
        }
      },
      "second-short": {
        "0": "сега",
        "future": {
          "one": "за {0} сек.",
          "other": "за {0} сек."
        },
        "past": {
          "one": "пред {0} сек.",
          "other": "пред {0} сек."
        }
      },
      "week": {
        "-1": "минатата седмица",
        "0": "оваа седмица",
        "1": "следната седмица",
        "future": {
          "one": "за {0} седмица",
          "other": "за {0} седмици"
        },
        "past": {
          "one": "пред {0} седмица",
          "other": "пред {0} седмици"
        }
      },
      "week-narrow": {
        "-1": "минатата седмица",
        "0": "оваа седмица",
        "1": "следната седмица",
        "future": {
          "one": "за {0} седмица",
          "other": "за {0} седмици"
        },
        "past": {
          "one": "пред {0} седмица",
          "other": "пред {0} седмици"
        }
      },
      "week-short": {
        "-1": "минатата седмица",
        "0": "оваа седмица",
        "1": "следната седмица",
        "future": {
          "one": "за {0} седмица",
          "other": "за {0} седмици"
        },
        "past": {
          "one": "пред {0} седмица",
          "other": "пред {0} седмици"
        }
      },
      "year": {
        "-1": "лани",
        "0": "оваа година",
        "1": "догодина",
        "future": {
          "one": "за {0} година",
          "other": "за {0} години"
        },
        "past": {
          "one": "пред {0} година",
          "other": "пред {0} години"
        }
      },
      "year-narrow": {
        "-1": "минатата год.",
        "0": "оваа год.",
        "1": "следната год.",
        "future": {
          "one": "за {0} год.",
          "other": "за {0} год."
        },
        "past": {
          "one": "пред {0} год.",
          "other": "пред {0} год."
        }
      },
      "year-short": {
        "-1": "минатата год.",
        "0": "оваа год.",
        "1": "следната год.",
        "future": {
          "one": "за {0} год.",
          "other": "за {0} год."
        },
        "past": {
          "one": "пред {0} год.",
          "other": "пред {0} год."
        }
      }
    },
    "locale": "mk"
  });
}